import config from '../../config';
import { useOrtto } from './';

export const useOrttoActivityCreateReport = () => {
	const { track } = useOrtto();
	const activity = config?.ortto?.createReport;
	return (userDestination) => track(activity, userDestination);
};
